"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptionLabel = exports.defaultOptionValue = void 0;
const utils_1 = require("./");
// This `any` is currently on purpose to ignore type errors in ChipSelectField
function defaultOptionValue(opt) {
    if (typeof opt !== "object" || !opt)
        (0, utils_1.fail)(`Option ${opt} has no id or code`);
    // Use `in` because returning undefined is fine
    return "id" in opt ? opt.id : "code" in opt ? opt.code : (0, utils_1.fail)(`Option ${JSON.stringify(opt)} has no id or code`);
}
exports.defaultOptionValue = defaultOptionValue;
function defaultOptionLabel(opt) {
    if (typeof opt !== "object" || !opt)
        (0, utils_1.fail)(`Option ${opt} has no id or code`);
    // Use `in` because returning undefined is fine
    return "name" in opt
        ? opt.name
        : "displayName" in opt
            ? opt.displayName
            : "label" in opt
                ? opt.label
                : (0, utils_1.fail)(`Option ${JSON.stringify(opt)} has no displayName, label, or name`);
}
exports.defaultOptionLabel = defaultOptionLabel;
